webpackJsonp([29],{

/***/ "2Z1J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("PIAa");

var _ShippingCostOverview = __webpack_require__("Ltl+");

var _ShippingCostOverview2 = _interopRequireDefault(_ShippingCostOverview);

var _Text = __webpack_require__("8/ml");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var margin = '0.81em 0 0.5em';

var ShippingHelp = function ShippingHelp() {
    return _react2.default.createElement(
        'article',
        { about: '/faq/recoloring', 'typeof': 'schema:WebPage' },
        _react2.default.createElement(
            _Text2.default,
            null,
            _react2.default.createElement(
                _Text2.default.Heading,
                { level: 2, margin: margin },
                'Wie lange braucht Ihr?'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Wir fertigen jeden Stoff individuell nach Bestelleingang. Es dauert deshalb ungef\xE4hr 3 Wochen bis wir Deinen individuellen Schnoff gedruckt, gewaschen, geb\xFCgelt und veredelt haben.'
            ),
            _react2.default.createElement(_Text2.default.Divider, null),
            _react2.default.createElement(
                _Text2.default.Heading,
                { level: 2, margin: margin },
                'Was kostet der Versand?'
            ),
            _react2.default.createElement(_ShippingCostOverview2.default, { showEuImage: true }),
            _react2.default.createElement(_Text2.default.Divider, null),
            _react2.default.createElement(
                _Text2.default.Heading,
                { level: 2, margin: margin },
                'Mit wem versendet Ihr?'
            ),
            _react2.default.createElement(
                'p',
                null,
                'Unser aktueller Versandpartner ist Hermes. Griffmuster versenden wir mit der Post. Wir planen aber, dass Ihr euch k\xFCnftig das Logistikunternehmen selbst w\xE4hlen k\xF6nnt. Das ist allerdings etwas aufw\xE4ndig und braucht noch Zeit.'
            )
        )
    );
};

exports.default = ShippingHelp;

/***/ }),

/***/ "8/ml":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = __webpack_require__("6GnX");

var _Heading2 = _interopRequireDefault(_Heading);

var _HorizontalDivider = __webpack_require__("SZDM");

var _HorizontalDivider2 = _interopRequireDefault(_HorizontalDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = function Text(_ref) {
    var colored = _ref.colored,
        children = _ref.children,
        className = _ref.className,
        margin = _ref.margin,
        left = _ref.left;

    var OuterTextContainer = _styledComponents2.default.div.withConfig({
        displayName: 'Text__OuterTextContainer',
        componentId: 'sc-89ig1k-0'
    })(['\n        background-color: ', ';\n        margin: ', ';\n    '], function (props) {
        return colored ? props.theme.palette.secondary.A200 : 'transparent';
    }, margin || '0');

    var InnerTextContainer = _styledComponents2.default.div.withConfig({
        displayName: 'Text__InnerTextContainer',
        componentId: 'sc-89ig1k-1'
    })(['\n        max-width: 66ch;\n        padding: ', ' ', ' ', ' ', ';\n        margin: ', ';\n    '], function (props) {
        return props.theme.space[5];
    }, function (props) {
        return props.theme.space[8];
    }, function (props) {
        return props.theme.space[5];
    }, function (props) {
        return props.theme.space[10];
    }, left ? '0' : '0 auto');

    return _react2.default.createElement(
        OuterTextContainer,
        { className: className },
        _react2.default.createElement(
            InnerTextContainer,
            null,
            children
        )
    );
};

Text.Heading = _Heading2.default;
Text.Divider = _HorizontalDivider2.default;

exports.default = Text;

/***/ }),

/***/ "EgZD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _faqShipping = __webpack_require__("2Z1J");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_faqShipping).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "ExK/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webp = _ref.webp,
        altText = _ref.altText,
        png = _ref.png,
        gif = _ref.gif;

    var StyledImage = _styledComponents2.default.img.withConfig({
        displayName: 'Picture__StyledImage',
        componentId: 'sc-sjj3zq-0'
    })(['\n        height: auto;\n        width: auto;\n        max-width: 100%;\n    ']);

    return _react2.default.createElement(
        'picture',
        null,
        webp ? _react2.default.createElement('source', { srcSet: webp, type: 'image/webp' }) : null,
        gif ? _react2.default.createElement('source', { srcSet: gif, type: 'image/gif' }) : null,
        _react2.default.createElement(StyledImage, { src: src, alt: altText || 'image' })
    );
};

exports.default = Picture;

/***/ }),

/***/ "Ltl+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _reactIntl = __webpack_require__("Pq8k");

var _prices = __webpack_require__("l28u");

var _title = __webpack_require__("LkcF");

var _ui = __webpack_require__("COkE");

var _Heading = __webpack_require__("6GnX");

var _Heading2 = _interopRequireDefault(_Heading);

var _EuShippingPaused = __webpack_require__("a1iK");

var _EuShippingPaused2 = _interopRequireDefault(_EuShippingPaused);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShippingCostOverview = function ShippingCostOverview(_ref) {
    var isShippingFree = _ref.isShippingFree,
        showEuImage = _ref.showEuImage;
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_Heading2.default, {
            level: 4, text: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'GERMANY',
                description: 'Label for the germany',
                defaultMessage: 'Deutschland'
            })
        }),
        _react2.default.createElement(
            'p',
            null,
            isShippingFree ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_COST_GERMANY_FREE',
                description: 'Label for the german shipping cost free.',
                defaultMessage: 'versandkostenfrei innerhalb Deutschlands'
            }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_COST_GERMANY_BELOW',
                description: 'Label for the german shipping cost below 125\u20AC.',
                defaultMessage: 'unter 125\u20AC - 5,95\u20AC'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            isShippingFree ? null : _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_COST_GERMANY_ABOVE',
                description: 'Label for the german shipping cost above 125\u20AC.',
                defaultMessage: '\xFCber 125\u20AC - versandkostenfrei'
            })
        ),
        _react2.default.createElement(_EuShippingPaused2.default, { headingLevel: 4, showImage: showEuImage }),
        _react2.default.createElement(_Heading2.default, {
            level: 4, text: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_WORLD',
                description: 'Label for the rest of the world shipping cost.',
                defaultMessage: 'Versand in Drittstaaten (Nicht EU)'
            })
        }),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_COST_WORLD',
                description: 'Text for the rest of the world shipping cost.',
                defaultMessage: '10\u20AC + 10% vom Bestellwert'
            })
        )
    );
};

var makeMapStateToProps = function makeMapStateToProps(initialState) {
    var shippingFree = (0, _prices.isShippingFree)(initialState);
    return function (state) {
        return {
            isShippingFree: shippingFree
        };
    };
};

exports.default = (0, _reactRedux.connect)(makeMapStateToProps)(ShippingCostOverview);

/***/ }),

/***/ "SZDM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.hr.withConfig({
    displayName: 'HorizontalDivider',
    componentId: 'sc-2e8hns-0'
})(['\n    border: 0;\n    height: 1px;\n    background-image: linear-gradient(to right, rgba(69, 90, 100, 0.05), rgba(69, 90, 100, 0.5), rgba(69, 90, 100, 0.05));\n    margin: ', ';\n    clear: both;\n    overflow: hidden;\n'], function (props) {
    return props.margin ? props.margin : '2em 0 1em';
});

/***/ }),

/***/ "a1iK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _Heading = __webpack_require__("6GnX");

var _Heading2 = _interopRequireDefault(_Heading);

var _Picture = __webpack_require__("ExK/");

var _Picture2 = _interopRequireDefault(_Picture);

var _euVersand = __webpack_require__("tjTu");

var _euVersand2 = _interopRequireDefault(_euVersand);

var _euVersand3 = __webpack_require__("s3Hw");

var _euVersand4 = _interopRequireDefault(_euVersand3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IMAGE_ALT_TEXT = 'Versandkarton mit EU-Flagge und Einfahrt-verboten-Schildern' + ' als Metapher für den bürokratisch verhinderten Versand in andere EU-Länder.';

/**
 * Explains why shipping to other EU countries is currently paused (PPWR).
 * Used in the shipping cost overview, which is shown in the shipping cost
 * dialog and on the shipping FAQ page.
 */
var EuShippingPaused = function EuShippingPaused(_ref) {
    var headingLevel = _ref.headingLevel,
        showImage = _ref.showImage;
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_Heading2.default, {
            level: headingLevel || 4, text: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_EU',
                description: 'Label for the EU shipping cost.',
                defaultMessage: 'Versand innerhalb der EU (pausiert)'
            })
        }),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_EU_PAUSED_INTRO',
                description: 'Intro of the paused EU shipping explanation.',
                defaultMessage: 'Europa, wir m\xFCssen reden. \uD83D\uDCE6'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_EU_PAUSED_STATUS',
                description: 'Statement that shipping within the EU is not possible at the moment.',
                defaultMessage: 'Wir w\xFCrden gern in die EU verschicken. K\xF6nnen wir gerade leider nicht. \uD83D\uDE35\u200D\uD83D\uDCAB'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_EU_PAUSED_PPWR',
                description: 'Explanation of the bureaucratic effort caused by the PPWR.',
                defaultMessage: 'Die PPWR macht aus einem kleinen Paket schnell einen kleinen B\xFCrokratie-Marathon: Registrierung, Meldungen, Bevollm\xE4chtigte, Geb\xFChren & Co. \u2013 je nach Zielland.'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_EU_PAUSED_REASON',
                description: 'Reason why the EU shipping is paused.',
                defaultMessage: 'F\xFCr einen Familienbetrieb schlicht unverh\xE4ltnism\xE4\xDFig. Deshalb ist unser EU-Ausland-Versand aktuell pausiert.'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_EU_PAUSED_CALL_TO_ACTION',
                description: 'Call to action to give feedback to the EU.',
                defaultMessage: 'Du findest das genauso absurd? Dann sag\u2019s der EU! \uD83D\uDC47'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: 'SHIPPING_EU_PAUSED_FEEDBACK_LINK',
                description: 'Link to the EU \u201EHave Your Say\u201C feedback form.',
                defaultMessage: '\uD83D\uDC49 Bis 10.09.2026 direkt bei \u201EGive Feedback\u201C: <a href="https://ec.europa.eu/info/law/better-regulation/have-your-say/initiatives/15352-Packaging-and-packaging-waste-rules-on-national-registers-of-producers_en" target="_blank" rel="noopener noreferrer">EU \u201EHave Your Say\u201C \u2013 Give Feedback</a>'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_EU_PAUSED_MEP',
                description: 'Hint to also contact the own member of the european parliament.',
                defaultMessage: 'Und gern auch deiner/deinem EU-Abgeordneten. \uD83D\uDC8C'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'SHIPPING_EU_PAUSED_OUTRO',
                description: 'Closing remark of the paused EU shipping explanation.',
                defaultMessage: 'Denn freier Warenverkehr sollte nicht hei\xDFen: frei von Waren, aber voller Formulare. \uD83D\uDE02'
            })
        ),
        showImage && _react2.default.createElement(_Picture2.default, { webp: _euVersand2.default, src: _euVersand4.default, altText: IMAGE_ALT_TEXT }),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: 'SHIPPING_LOGOIX',
                description: 'Text f\xFCr den logoix.com Versandservice.',
                defaultMessage: 'F\xFCr Kunden in der EU bietet <a href="https://www.logoix.com/" target="_blank" rel="noopener noreferrer">logoix.com</a> eine L\xF6sung. N\xE4here Informationen findest Du unter <a href="https://www.logoix.com/" target="_blank" rel="noopener noreferrer">logoix.com</a>.'
            })
        )
    );
};

exports.default = EuShippingPaused;

/***/ }),

/***/ "s3Hw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/eu-versand.5a10c01f.jpg";

/***/ }),

/***/ "tjTu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/eu-versand.ba44d8fb7d9a5e162bcbefe838f87eb4.webp";

/***/ })

});


// WEBPACK FOOTER //
// async/deShipping.21f14cdaa8ac73ed4d25.js